(function () {

    var errors = false;
    const contactForms = document.getElementsByClassName("contactform")

    if (contactForms && contactForms.length) {

        for (let i = 0; i < contactForms.length; i++) {

            const contactForm = contactForms[i]
            const errorElements = contactForm.getElementsByClassName("field-validation-error");
            const sent = contactForm.getElementsByClassName("sent").length > 0
            if (errorElements.length > 0 || sent > 0) {
                const topPosition = contactForm.getBoundingClientRect().top + window.scrollY - 100;
                window.scrollTo({
                    top: topPosition,
                    behavior: 'smooth'
                });
                break;
            }
        }


    }
})();